import { render, staticRenderFns } from "./inputForm.vue?vue&type=template&id=4e6466d5&"
import script from "./inputForm.vue?vue&type=script&lang=js&"
export * from "./inputForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports